<template>
  <div id="app">
    <b-navbar toggleable type="dark" variant="dark" sticky>
      <b-navbar-brand href="/">Tools</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-for="route in routes" :key="route.id" :href="route.path">{{ route.name }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view/>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'App',
  data() {
    return {
      routes: router.options.routes
    }
  }
}
</script>

<style>
#app {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue